export default {"src":"/_next/static/image/public/images/ic_delivered_pending.b54632fbb168f5911e0cfe25210637ac.svg","height":53,"width":56};